import _ from 'lodash';
import { helperGetApiRouteById } from 'helpers/ApiHelper';
import { getUrlTarget } from 'helpers/ContentHelper';

export const getPromoListApiUrl = promoListUrl => {
  const contentId = _.split(promoListUrl, '/').pop();
  return helperGetApiRouteById(contentId);
};

export const promoListProcessor = item => {
  if (!item) return null;
  const { '@id': id, headline, images, name, url } = item;

  const image = _.get(images, 'link');
  const targetData = getUrlTarget(url);

  const promoData = {
    id,
    link: url,
    title: headline,
    subtitle: name,
    image,
    ...targetData,
    // trackButtonClick: tealiumButtonAction,
  };

  return promoData;
};
